// Verstuurt één inzending van het publieke intakeformulier naar de Cloud
// Function. De pagina schrijft niet zelf in Firestore: `Adresses`/`Personas`
// staan op team-only, dus een anonieme bewoner kon zijn huishouden niet
// aanmaken en de inzending liep vast. De functie doet het als beheerder.
// AI-CONTEXT: See docs/patterns.md#cf-public-anonymous-callable
// AI-CONTEXT: See docs/decisions.md#adr-022
import firebase from '../../firebase/compat';

/**
 * @param {object} submission - Payload uit buildIntakeSubmission
 * @returns {Promise<{ok: true}>} Altijd hetzelfde: de functie verklapt niet of het adres al bekend was
 */
const submitIntakeForm = async (submission) => {
    // De regio staat er expliciet bij: de standaardclient wijst naar
    // us-central1 en vindt de functie daar niet (CLAUDE.md style rule 16).
    const callable = firebase
        .app()
        .functions('europe-west1')
        .httpsCallable('saveIntakeFormResponse');

    const result = await callable(submission);
    return result.data;
};

export default submitIntakeForm;
